/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomFieldsSchemaDtoPage } from '../../models/custom-fields-schema-dto-page';

export interface ListCustomFieldsSchema$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'fields' | '-fields' | 'isCurrent' | '-isCurrent' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listCustomFieldsSchema(http: HttpClient, rootUrl: string, params?: ListCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listCustomFieldsSchema.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomFieldsSchemaDtoPage>;
    })
  );
}

listCustomFieldsSchema.PATH = '/v0/CustomFieldsSchema';
